import React from "react";
import PageContainer from "../../../../components/containers/PageContainer";
import { LubricantInterface } from "../../../../domains/lubricant/model/LubricantInterface";
import { useLangLabels } from "../../../../shared/lang/services/useLangLabels";
import CreateUpdateIncomeForm from "./CreateUpdateIncomeForm";
import { CrudFormType } from "../../../../shared/form/types/FormTypes";
import { useGetIncome } from "../services/IncomeService";
import { useIncomeGridModel } from "../lang/useIncomeGridModel";
import DeleteIncomeForm from "./DeleteIncomeForm";
import { CarrousellActionInterface } from "../../../../shared/react-table/VirtualGrid/types/VirtualGridTypes";
import VirtualGrid from "../../../../shared/react-table/VirtualGrid/VirtualGrid";

interface LubricantIncomeProps {
  item?: LubricantInterface;
  lubricant?: string;
}

const LubricantIncome = ({ item, lubricant }: LubricantIncomeProps) => {
  const { lang } = useLangLabels();
  const { data: incomes, isFetching } = useGetIncome(item?.lubricant);

  const carrousellActions: CarrousellActionInterface = [
    {
      icon: "edit",
      popoverTitle: lang.messages.latestIncome,
      component: item => (
        <CreateUpdateIncomeForm
          actionType={CrudFormType.update}
          lubricant={lubricant}
          item={item}
          isDataUpdated={!isFetching}
        />
      ),
    },
  ];

  return (
    <PageContainer>
      <VirtualGrid
        {...{
          key: item?.id,
          height: lubricant ? 10 : undefined,
          contained: false,
          width: "100%",
          title: lang.messages.latestIncome,
          documentExportTitle: "Ultimos Ingresos",
          items: incomes || [],
          gridModel: useIncomeGridModel(),
          entityName: lang.incomeForm.plural,
          carrousellComponents: lubricant ? undefined : carrousellActions,
          headerActions: () => (
            <CreateUpdateIncomeForm lubricant={lubricant} actionType={CrudFormType.create} />
          ),
          itemActions: item => (
            <>
              <DeleteIncomeForm key={1} item={item} />
              {lubricant ? (
                <CreateUpdateIncomeForm
                  key={2}
                  actionType={CrudFormType.update}
                  lubricant={lubricant}
                  item={item}
                  mode={"modal"}
                  isDataUpdated={!isFetching}
                />
              ) : undefined}
            </>
          ),
        }}
      />
    </PageContainer>
  );
};

export default React.memo(LubricantIncome);
